import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CancelDialogService {
  private _isOpen = new BehaviorSubject<boolean>(false);
  private _onConfirm = new BehaviorSubject<(() => void) | null>(null);

  public isOpen$ = this._isOpen.asObservable();
  public onConfirm$ = this._onConfirm.asObservable();

  constructor() { }

  openDialog(onConfirmCallback?: () => void): void {
    this._onConfirm.next(onConfirmCallback || null);
    this._isOpen.next(true);
  }

  closeDialog(): void {
    this._isOpen.next(false);
    this._onConfirm.next(null);
  }

  confirmAction(): void {
    const callback = this._onConfirm.value;
    this.closeDialog();
    if (callback) {
      callback();
    }
  }
}